<div appGlobalBinds>
  <router-outlet></router-outlet>
</div>
